import React from 'react'
import { twMerge } from 'tailwind-merge'

import { CloseIcon, SearchIcon } from '../../icons'
import { Icon } from '../icon'
import { Input, InputField, InputSlot } from '../input'
import { Pressable } from '../pressable'

export type SearchInputProps = {
    value: string
    placeholder?: string
    onChangeText(value: string): void
    onClear(): void
    className?: string
}

export const SearchInput = ({
    value,
    placeholder,
    onChangeText,
    onClear,
    className,
}: SearchInputProps) => (
    <Input className={twMerge('w-[280px]', className)}>
        <InputSlot>
            <Icon as={SearchIcon} size={24} className='text-aos-text-default' />
        </InputSlot>
        <InputField value={value} placeholder={placeholder} onChangeText={onChangeText} />
        {!!value && (
            <Pressable accessibilityRole='button' onPress={onClear}>
                <Icon as={CloseIcon} size={20} className='text-aos-text-muted' />
            </Pressable>
        )}
    </Input>
)

SearchInput.displayName = 'SearchInput'
